const GT_PDP_ACCORDION_DURATION_MS = 350;

function gtPdpAccordionReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function gtPdpAccordionOpen(details, panel) {
  details.setAttribute('open', '');
  const summary = details.querySelector('summary');
  summary?.setAttribute('aria-expanded', 'true');

  if (gtPdpAccordionReducedMotion()) {
    panel.style.height = '';
    panel.style.overflow = '';
    return;
  }

  details.classList.add('gt-pdp__accordion--animating');
  panel.style.overflow = 'hidden';
  panel.style.height = '0px';

  requestAnimationFrame(() => {
    panel.style.height = `${panel.scrollHeight}px`;
  });

  const finish = () => {
    if (!details.hasAttribute('open')) return;
    panel.style.height = 'auto';
    panel.style.overflow = '';
    details.classList.remove('gt-pdp__accordion--animating');
    panel.removeEventListener('transitionend', onTransitionEnd);
    window.clearTimeout(fallbackId);
  };

  const onTransitionEnd = (event) => {
    if (event.target !== panel || event.propertyName !== 'height') return;
    finish();
  };

  const fallbackId = window.setTimeout(finish, GT_PDP_ACCORDION_DURATION_MS + 50);
  panel.addEventListener('transitionend', onTransitionEnd);
}

function gtPdpAccordionClose(details, panel) {
  const summary = details.querySelector('summary');
  summary?.setAttribute('aria-expanded', 'false');

  if (gtPdpAccordionReducedMotion()) {
    details.removeAttribute('open');
    panel.style.height = '';
    panel.style.overflow = '';
    return;
  }

  details.classList.add('gt-pdp__accordion--animating');
  panel.style.overflow = 'hidden';
  panel.style.height = `${panel.scrollHeight}px`;

  requestAnimationFrame(() => {
    panel.style.height = '0px';
  });

  const finish = () => {
    details.removeAttribute('open');
    panel.style.height = '';
    panel.style.overflow = '';
    details.classList.remove('gt-pdp__accordion--animating');
    panel.removeEventListener('transitionend', onTransitionEnd);
    window.clearTimeout(fallbackId);
  };

  const onTransitionEnd = (event) => {
    if (event.target !== panel || event.propertyName !== 'height') return;
    finish();
  };

  const fallbackId = window.setTimeout(finish, GT_PDP_ACCORDION_DURATION_MS + 50);
  panel.addEventListener('transitionend', onTransitionEnd);
}

function initGtPdpAccordion(details) {
  if (details.dataset.gtAccordionInit === 'true') return;

  const summary = details.querySelector('summary');
  const panel = details.querySelector('.gt-pdp__accordion-content');
  if (!summary || !panel) return;

  details.dataset.gtAccordionInit = 'true';
  panel.classList.add('gt-pdp__accordion-panel');

  if (details.hasAttribute('open')) {
    summary.setAttribute('aria-expanded', 'true');
    if (!gtPdpAccordionReducedMotion()) {
      panel.style.height = 'auto';
    }
  } else {
    summary.setAttribute('aria-expanded', 'false');
  }

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    if (details.classList.contains('gt-pdp__accordion--animating')) return;

    if (details.hasAttribute('open')) {
      gtPdpAccordionClose(details, panel);
    } else {
      gtPdpAccordionOpen(details, panel);
    }
  });
}

function initGtPdpAccordions(root = document) {
  root.querySelectorAll('.gt-pdp__accordion details').forEach(initGtPdpAccordion);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initGtPdpAccordions());
} else {
  initGtPdpAccordions();
}

document.addEventListener('shopify:section:load', (event) => {
  initGtPdpAccordions(event.target);
});
